// extracted by mini-css-extract-plugin
module.exports = {"favorites__header":"favorites_favorites__header__yaVVY"};